import { render, staticRenderFns } from "./Barometer.vue?vue&type=template&id=00dd8bcc&scoped=true"
import script from "./Barometer.vue?vue&type=script&lang=js"
export * from "./Barometer.vue?vue&type=script&lang=js"
import style0 from "./Barometer.vue?vue&type=style&index=0&id=00dd8bcc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dd8bcc",
  null
  
)

export default component.exports